import imgNPS from '../../img/nps90.png';

const Meta = () => {
    return (
        <div className="container-fluid meta">
            <div className="container py-3">
                <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="sub-style">
                        <h4 className="sub-title px-3 mb-0">Nossa Meta</h4>
                    </div>
                    <h1 className="display-3 mb-4">NPS 90</h1>
                    <p className="mb-0">Uma pontuação de NPS (Net Promoter Score) entre 76 e 100 é considerada excelente e indica que a empresa está no
                        caminho certo para a excelência.</p>
                    <div className='py-5'>
                        <img src={imgNPS} className='imgMetaNPS' alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Meta;